declare const process: any
import { http } from '@Techedge/digitalportal-shared'

export class SidebarServices {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
    static GRSD_URL: string =
        SidebarServices.BASE_URL + `/commonapi/user/refresh_token`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static GetGRSDToken = () => {
        return http.get<any>(SidebarServices.GRSD_URL, {
            ...SidebarServices.headersObj,
        })
    }
    static GetSocialHubConfiguration = () => {
        return http.get<any>(
            `${SidebarServices.BASE_URL}/profileapi/profile/social/profile`,
            {
                ...SidebarServices.headersObj,
            }
        )
    }
}
